import script from "./Manifesto.vue?vue&type=script&setup=true&lang=ts"
export * from "./Manifesto.vue?vue&type=script&setup=true&lang=ts"

import "./Manifesto.vue?vue&type=style&index=0&id=2129db64&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2129db64"]])

export default __exports__